import { GenerateModalWithSuspense } from "@libs/modal-panels/modal-registry-helpers";
import { iModalProps } from "@libs/modal-panels/modal-registry-model";
import React from "react";

const ConversationsExplorerModal = React.lazy(
  () => import("./conversations-explorer.modal"),
);

const ConversationsExplorer: iModalProps<
  typeof ConversationsExplorerModal,
  {
    filter: any;
    zIndex?: number;
  }
> = {
  name: "conversations-explorer",
  component: GenerateModalWithSuspense(ConversationsExplorerModal),
};

export default ConversationsExplorer;
